import React, { useEffect, useState } from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQuery } from '@tanstack/react-query';
import { getFuels } from '../../../services/Edits.service';
import { GET_FUELS } from '../../../queries';

export function FuelsForm(): JSX.Element {
  const { setCurrentContent, loading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { combustivelId = 0 } = currentAd?.veiculo || {};
  const [selectedRadio, setSelectedRadio] = useState(combustivelId);

  const { data, isInitialLoading } = useQuery({
    queryKey: [GET_FUELS],
    queryFn: () => getFuels()
  });

  useEffect(() => {
    setValueIsDifferentFromCurrent(selectedRadio !== combustivelId);
  }, [selectedRadio, combustivelId, setValueIsDifferentFromCurrent]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          qual o tipo de combustível?
        </Title>
      </OpenEditTitleWrapper>
      {isInitialLoading && <Loading />}

      <List>
        {data ? (
          data.map(({ id, nome }) => {
            const gnvToLowerCase = nome.includes('GNV') && nome.toLowerCase();
            const result = gnvToLowerCase && gnvToLowerCase.replace('gnv', 'GNV');
            return (
              <ListItemModifier key={id} isNormalCase={nome.includes('GNV')}>
                <ListItem
                  label={result ? result : nome}
                  variant="selector"
                  radioOnChange={() => setSelectedRadio(id)}
                  radioValue={id}
                  radioChecked={id === selectedRadio}
                  selectorName={nome}
                  selectorVariant="radio"
                />
              </ListItemModifier>
            );
          })
        ) : (
          <></>
        )}
      </List>

      {!(isInitialLoading && selectedRadio === combustivelId) && (
        <SaveFormContent
          loading={loading}
          isBody
          isDisabled={selectedRadio === combustivelId}
          handleClick={() =>
            setCurrentContent({
              veiculo: {
                combustivelNome: data?.find(fuel => fuel.id === selectedRadio)?.nome,
                combustivelId: selectedRadio
              }
            })
          }
        />
      )}
    </OpenEditWrapper>
  );
}
